import { Configuration } from '../../types/configuration';
import { Domain } from '../../types/domain';
import { CountryEnum } from '../../types/country';

export const LOCAL_APP_CONFIG: Configuration = {
  domainMapping: {
    [Domain.AT]: [
      { sbResource: 'at', buildAs: '' },
      { sbResource: 'at-de/article', buildAs: 'de/article', articleUserType: 'retail' },
      { sbResource: 'at-en/article', buildAs: 'en/article', articleUserType: 'retail' },
      { sbResource: 'at-de/global', buildAs: 'de/global' },
      { sbResource: 'at-en/global', buildAs: 'en/global' },
      { sbResource: 'at-de/privat-anleger', buildAs: 'de' },
      { sbResource: 'at-en/retail', buildAs: 'en' },
    ],
    [Domain.DE]: [
      { sbResource: 'de', buildAs: '' },
      { sbResource: 'de-de/article', buildAs: 'de/article', articleUserType: 'retail' },
      { sbResource: 'de-de/global', buildAs: 'de/global' },
      { sbResource: 'de-de/privat-anleger', buildAs: 'de' },
    ],
    [Domain.HR]: [
      { sbResource: 'hr', buildAs: '' },
      { sbResource: 'hr-en/article', buildAs: 'en/article', articleUserType: 'retail' },
      { sbResource: 'hr-en/global', buildAs: 'en/global' },
      { sbResource: 'hr-en/retail', buildAs: 'en' },
    ],
    [Domain.IT]: [
      { sbResource: 'it', buildAs: '' },
      { sbResource: 'it-it/article', buildAs: 'it/article', articleUserType: 'retail' },
      { sbResource: 'it-it/global', buildAs: 'it/global' },
      { sbResource: 'it-it/retail', buildAs: 'it' },
    ],
    [Domain.SI]: [
      { sbResource: 'si', buildAs: '' },
      { sbResource: 'si-en/article', buildAs: 'en/article', articleUserType: 'retail' },
      { sbResource: 'si-en/global', buildAs: 'en/global' },
      { sbResource: 'si-en/retail', buildAs: 'en' },
    ],
    [Domain.INSTI]: [
      { sbResource: 'at-de', buildAs: 'at-de', exclude: ['at-de/privat-anleger'], articleUserType: 'institutional,cee' },
      { sbResource: 'at-en', buildAs: 'at-en', exclude: ['at-en/retail'], articleUserType: 'institutional,cee' },
      { sbResource: 'de-de', buildAs: 'de-de', exclude: ['de-de/privat-anleger'], articleUserType: 'institutional,cee' },
      { sbResource: 'it-it', buildAs: 'it-it', exclude: ['it-it/retail'], articleUserType: 'institutional,cee' },
      { sbResource: 'hr-en', buildAs: 'hr-en', exclude: ['hr-en/retail'], articleUserType: 'institutional,cee' },
      { sbResource: 'si-en', buildAs: 'si-en', exclude: ['si-en/retail'], articleUserType: 'institutional,cee' },
      { sbResource: 'ch-de', buildAs: 'ch-de' },
      { sbResource: 'fr-fr', buildAs: 'fr-fr' },
      { sbResource: 'cz-en', buildAs: 'cz-en' },
      { sbResource: 'es-en', buildAs: 'es-en' },
      { sbResource: 'hu-en', buildAs: 'hu-en' },
      { sbResource: 'lu-en', buildAs: 'lu-en' },
      { sbResource: 'ro-en', buildAs: 'ro-en' },
      { sbResource: 'sk-en', buildAs: 'sk-en' },
      { sbResource: 'li-de', buildAs: 'li-de' },
      { sbResource: 'bg-en', buildAs: 'bg-en' },
      { sbResource: 'pl-en', buildAs: 'pl-en' },
      { sbResource: 'rcm-int', buildAs: 'rcm-int' },
    ],
  },
  retailDomains: [Domain.AT, Domain.DE, Domain.IT, Domain.HR, Domain.SI],
  institutionalDomains: [Domain.INSTI],
  rebrandedCountries: [CountryEnum.AT, CountryEnum.DE, CountryEnum.IT, CountryEnum.HR, CountryEnum.SI],
  retailDomainCountryMap: {
    [Domain.AT]: CountryEnum.AT,
    [Domain.DE]: CountryEnum.DE,
    [Domain.IT]: CountryEnum.IT,
    [Domain.HR]: CountryEnum.HR,
    [Domain.SI]: CountryEnum.SI,
  },
  domainToUrlMapping: {
    [Domain.AT]: process.env.GATSBY_AT_WEBSITE_URL,
    [Domain.DE]: process.env.GATSBY_DE_WEBSITE_URL,
    [Domain.HR]: process.env.GATSBY_HR_WEBSITE_URL,
    [Domain.IT]: process.env.GATSBY_IT_WEBSITE_URL,
    [Domain.SI]: process.env.GATSBY_SI_WEBSITE_URL,
    [Domain.INSTI]: process.env.GATSBY_INSTI_WEBSITE_URL,
  },
  domainToOnetrustKeyMap: {
    [Domain.AT]: process.env.GATSBY_ONETRUST_KEY_AT,
    [Domain.DE]: process.env.GATSBY_ONETRUST_KEY_DE,
    [Domain.IT]: process.env.GATSBY_ONETRUST_KEY_IT,
    [Domain.HR]: process.env.GATSBY_ONETRUST_KEY_HR,
    [Domain.SI]: process.env.GATSBY_ONETRUST_KEY_SI,
    [Domain.INSTI]: process.env.GATSBY_ONETRUST_KEY_INSTI,
  },
};
